export default __webpack_public_path__ + "fonts/a8bdcb606448225c149ec6ed2d89886f.eot";